module.exports = __webpack_public_path__ + "img/cloud-intercom-no-contract.c746f087.webp";